import { useTranslation } from 'next-i18next'

import { FooterBadges } from './footer-badges'
import { FooterLinks } from './footer-links'
import { CopyrightContainer, CopyrightText, FooterContainer, SrOnlyHeading } from './styled'

type GlobalFooterProps = {
  mobileHidden?: boolean
}

export const GlobalFooter = ({ mobileHidden = false }: GlobalFooterProps) => {
  const { t } = useTranslation('global_footer')

  return (
    <FooterContainer
      $mobileHidden={mobileHidden}
      aria-labelledby="footerAccessibilityLabel"
      id="footer"
    >
      <SrOnlyHeading id="footerAccessibilityLabel">{t('accessibility_label')}</SrOnlyHeading>

      <FooterLinks />
      <FooterBadges />

      <CopyrightContainer>
        <CopyrightText>{t('copyright.fine_print')}</CopyrightText>
      </CopyrightContainer>
    </FooterContainer>
  )
}
